<template>
  <div class="wechat-toast">
    <template v-if="show">
      <img :src='require(`../../assets/img/components/wechatBinding/${imgUrl}`)' alt=""/>
      <div class="content-text">{{typeInfoData.text}}</div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      typeInfoData: {},
      imgUrl: '',
    };
  },
  props: {
    typeInfo: {
      type: Object,
      default: () => ({
        type: 'success',
        text: '成功',
      }),
    },
  },
  mounted() {
    this.init(this.typeInfo);
  },
  methods: {
    init(val) {
      if (val.type === 'success') {
        this.imgUrl = 'icon_success.png';
      } else if (val.type === 'warn') {
        this.imgUrl = 'icon_warn.png';
      }
    },

    toastShow(val) {
      this.typeInfoData = val || this.typeInfo;
      this.init(val);
      this.show = true;
      if (val.duration === 'allTime') {
        return;
      }
      setTimeout(() => {
        this.show = false;
      }, 2000);
    },
  },
};
</script>

<style scoped lang="scss">
.wechat-toast{
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3000;
  width: 474px;
  text-align: center;
  background: rgba(0,0,0,0.8);
  border-radius: 24px;
  transform: translate3d(-50%,-50%,0);

  img{
    width: 60px;
    height: 60px;
    margin-top: 48px;
  }

  .content-text{
    width: 70%;
    margin: 32px 15% 48px;
    color: #FFF;
    font-size: 32px;
    line-height: 44px;
  }
}
</style>
